const countUp = new CountUp( 'e-commerce-counter', 0,
{
  startVal: 60,
  duration: 60,
  useEasing: false
} );



const update_prices = () =>
{
  const prices_elements = Array.from( cached_elements.get_nodelist( '[data-eprice]' ) );

  for ( el of prices_elements )
  {
    const current_price = Number( el.getAttribute( 'data-eprice' ) );
    const increased_price = Math.round(Number( ( current_price * 1.01 ).toFixed( 2 ) ));

    start_countup( current_price, increased_price, el.id );
    el.setAttribute( 'data-eprice', increased_price );
  }

  reset_countup();
}

const start_countup = ( current_price, increased_price, target_id ) =>
{
  const countUp = new CountUp( target_id, increased_price,
  {
    startVal: current_price,
    decimalPlaces: 2,
    prefix: '$',
  } ).start();
}


const reset_countup = () =>
{
  setTimeout( () =>
  {
    countUp.reset();
    setTimeout( () =>
    {
      countUp.start( update_prices );
    }, 900 );
  }, 5000 );

}
countUp.start( update_prices );